import { END_POINTS } from '../helpers';
import emptySplitApi from '../utils/rtk';

type CommonResponseType = {
  status: number;
  message: string;
  statusCode: number;
  page: number;
  limit: number;
  data: any;
  statusType: number;
};

export const InspectionApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getInspection: builder.query<
      CommonResponseType,
      { page: number; limit: number; statusType?: number }
    >({
      query: ({ page, limit, statusType }) => ({
        url: `${END_POINTS.inspection}?status=${statusType}&page=${page}&limit=${limit}`,
        method: 'GET',
      }),
    }),

    gwtInspectionById: builder.query<CommonResponseType, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.getInspectionById}/${id}`,
        method: 'GET',
      }),
    }),
    uploadReport: builder.mutation<CommonResponseType, { id: string; body: any }>({
      query: ({ id, body }) => ({
        url: `${END_POINTS.uploadReport}/${id}`,
        method: 'PUT',
        body,
      }),
    }),
  }),
});

export const { useLazyGetInspectionQuery, useLazyGwtInspectionByIdQuery, useUploadReportMutation } =
  InspectionApi;
